import i18next from 'i18next';
import config from 'react-global-configuration';
import { useSelector } from 'react-redux';

import { __DEBUG__ } from '../constants';
import nl from './locales/nl/nl.json';
import nlVNL from './locales/nl/domains/vnl.json';
import nlKVNL from './locales/nl/domains/kvnl.json';

const domainTranslationsMapping = {
  nl: {
    vnl: nlVNL,
    kvnl: nlKVNL
  }
};

const LanguageConfig = () => {
  const currentDomain = config.get('CURRENT_DOMAIN');
  const currentLanguage = useSelector((state) => state.getIn(['ui', 'language']));
  const domainSpecificTranslationFile = domainTranslationsMapping[currentLanguage][currentDomain];

  i18next.init({
    fallbackLng: 'nl',
    defaultNS: "domain",
    fallbackNS: ['app'],
    returnEmptyString: false,
    resources: {
      nl: {
        domain: domainSpecificTranslationFile.translation,
        app: nl.translation
      }
    },
    parseMissingKeyHandler: (missing) => {
      if (__DEBUG__) {
        console.warn('MISSING TRANSLATION:', missing);
      }
      return missing;
    },
  });

  i18next.languages = ['nl', 'en'];

  return i18next;
}

export default LanguageConfig;
